export default "__VITE_PUBLIC_ASSET__8d419ab4__"